import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setLastUrlWithFilters } from 'variables/filters'

export const useSetLastUrlWithFilters = (): void => {
  const location = useLocation()
  const setUrl = useCallback((): void => {
    setLastUrlWithFilters({
      pathname: location.pathname,
      searchQuery: location.search
    })
  }, [location])
  useEffect(() => {
    return () => {
      setUrl()
    }
  }, [setUrl])
}
